import CustomPopup from '@/components/customPopup/CustomPopup';
import { useTranslation } from 'react-i18next';
interface DialogFailurePaymentInterface {
  setShowPopUp: (showPopUp: boolean) => void;
  showPopUp: boolean;
  buttonActionArray?: (() => void)[];
}

export const DialogFailurePayment = ({
  setShowPopUp,
  showPopUp,
  buttonActionArray,
}: DialogFailurePaymentInterface) => {
  const { t } = useTranslation('schedule');
  return (
    <CustomPopup
      title={t('modal_error_payment_credit_card_title')}
      description={t('modal_error_payment_credit_card_description')}
      popupHidden={!showPopUp}
      imageHidden
      closeHidden
      closeAction={() => setShowPopUp(false)}
      buttonTitleArray={[
        t('Ok'),
      ]}
      buttonOnlyTextArray={[false, true]}
      buttonOutlinedArray={[false, true]}
      buttonColorArray={['error', 'error']}
      buttonActionArray={buttonActionArray ?? []}
    />
  );
};
